import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpclientService } from "../../../shared/services/httpclient.service";

@Injectable()
export class StaffTypeService {
	constructor(private httpclientService: HttpclientService) {}
	loadSTAFFTYPEList(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/STAFFTYPEGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
